




















import enterpriseData from '@/components/Company/newCompany/companyInfo/enterpriseData.vue';
import enterpriseAddress from '@/components/Company/newCompany/companyInfo/enterpriseAddress.vue';
import enterpriseComissions from '@/components/Company/newCompany/companyInfo/enterpriseComissions.vue';
import contactTypes from '@/store/types/contact';
import contacts from './companyInfo/forms/contacts.vue';
import company from '@/store/types/company';
import { mapGetters } from 'vuex';
import Vue from 'vue';

export default Vue.extend({
  name: 'NewCompanyInfo',
  components: {
    enterpriseData,
    enterpriseAddress,
    enterpriseComissions,
    contacts,
  },
  computed: {
    ...mapGetters({
      getContactKind: `contactModule/${contactTypes.getters.GET_CONTACT_KIND}`,
      getNewCompanyParams: `companyModule/${company.getters.GET_NEW_COMPANY_PARAMS}`,
    }),
  },
});
